export default __webpack_public_path__ + "0b4a060f300bb70eb34b95e8cf4ea6cc.png";